"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardName_1 = require("@/common/cards/CardName");
const logos = {
    [CardName_1.CardName.ADHAI_HIGH_ORBIT_CONSTRUCTIONS]: 'image',
    [CardName_1.CardName.AERON_GENOMICS]: 'bespoke',
    [CardName_1.CardName.AGRICOLA_INC]: 'bespoke',
    [CardName_1.CardName.AMBIENT]: 'image',
    [CardName_1.CardName.ANUBIS_SECURITIES]: 'bespoke',
    [CardName_1.CardName.APHRODITE]: 'css',
    [CardName_1.CardName.ARBORIST_COLLECTIVE]: 'bespoke',
    [CardName_1.CardName.ARCADIAN_COMMUNITIES]: 'bespoke',
    [CardName_1.CardName.ARIDOR]: 'css',
    [CardName_1.CardName.ARKLIGHT]: 'css',
    [CardName_1.CardName.ASTRODRILL]: 'bespoke',
    [CardName_1.CardName.ATHENA]: 'bespoke',
    [CardName_1.CardName.AURORAI]: 'image',
    [CardName_1.CardName.BIO_SOL]: 'image',
    [CardName_1.CardName.CELESTIC]: 'bespoke',
    [CardName_1.CardName.CHEUNG_SHING_MARS]: 'bespoke',
    [CardName_1.CardName.CHIMERA]: 'image',
    [CardName_1.CardName.COLLEGIUM_COPERNICUS]: 'image',
    [CardName_1.CardName.CREDICOR]: 'css',
    [CardName_1.CardName.CRESCENT_RESEARCH_ASSOCIATION]: 'bespoke',
    [CardName_1.CardName.CURIOSITY_II]: 'bespoke',
    [CardName_1.CardName.DEMETRON_LABS]: 'bespoke',
    [CardName_1.CardName.ECOLINE]: 'css',
    [CardName_1.CardName.ECOTEC]: 'bespoke',
    [CardName_1.CardName.ERIS]: 'bespoke',
    [CardName_1.CardName.FACTORUM]: 'css',
    [CardName_1.CardName.GAGARIN_MOBILE_BASE]: 'bespoke',
    [CardName_1.CardName.HABITAT_MARTE]: 'image',
    [CardName_1.CardName.HADESPHERE]: 'bespoke',
    [CardName_1.CardName.HECATE_SPEDITIONS]: 'bespoke',
    [CardName_1.CardName.HELION]: 'css',
    [CardName_1.CardName.HENKEI_GENETICS]: 'bespoke',
    [CardName_1.CardName.INCITE]: 'bespoke',
    [CardName_1.CardName.INTERPLANETARY_CINEMATICS]: 'bespoke',
    [CardName_1.CardName.INTRAGEN_SANCTUARY_HEADQUARTERS]: 'image',
    [CardName_1.CardName.INVENTRIX]: 'bespoke',
    [CardName_1.CardName.JENSON_BOYLE_CO]: 'css',
    [CardName_1.CardName.JUNK_VENTURES]: 'css',
    [CardName_1.CardName.KEPLERTEC]: 'bespoke',
    [CardName_1.CardName.KINGDOM_OF_TAURARO]: 'bespoke',
    [CardName_1.CardName.KUIPER_COOPERATIVE]: 'bespoke',
    [CardName_1.CardName.LAKEFRONT_RESORTS]: 'bespoke',
    [CardName_1.CardName.LUNA_FIRST_INCORPORATED]: 'image',
    [CardName_1.CardName.LUNA_HYPERLOOP_CORPORATION]: 'image',
    [CardName_1.CardName.LUNA_TRADE_FEDERATION]: 'image',
    [CardName_1.CardName.MANUTECH]: 'bespoke',
    [CardName_1.CardName.MARS_DIRECT]: 'image',
    [CardName_1.CardName.MARS_FRONTIER_ALLIANCE]: 'image',
    [CardName_1.CardName.MARS_MATHS]: 'bespoke',
    [CardName_1.CardName.MARTIAN_INSURANCE_GROUP]: 'image',
    [CardName_1.CardName.MIDAS]: 'css',
    [CardName_1.CardName.MIND_SET_MARS]: 'image',
    [CardName_1.CardName.MINING_GUILD]: 'bespoke',
    [CardName_1.CardName.MONS_INSURANCE]: 'bespoke',
    [CardName_1.CardName.MORNING_STAR_INC]: 'css',
    [CardName_1.CardName.NANOTECH_INDUSTRIES]: 'image',
    [CardName_1.CardName.NIRGAL_ENTERPRISES]: 'bespoke',
    [CardName_1.CardName.ODYSSEY]: 'image',
    [CardName_1.CardName.PALLADIN_SHIPPING]: 'bespoke',
    [CardName_1.CardName.PHARMACY_UNION]: 'bespoke',
    [CardName_1.CardName.PHILARES]: 'bespoke',
    [CardName_1.CardName.PHOBOLOG]: 'css',
    [CardName_1.CardName.PLAYWRIGHTS]: 'bespoke',
    [CardName_1.CardName.POINT_LUNA]: 'css',
    [CardName_1.CardName.POLARIS]: 'image',
    [CardName_1.CardName.POLDERTECH_DUTCH]: 'bespoke',
    [CardName_1.CardName.POLYPHEMOS]: 'css',
    [CardName_1.CardName.POSEIDON]: 'css',
    [CardName_1.CardName.PRISTAR]: 'css',
    [CardName_1.CardName.PROJECT_WORKSHOP]: 'bespoke',
    [CardName_1.CardName.RECYCLON]: 'bespoke',
    [CardName_1.CardName.RINGCOM]: 'image',
    [CardName_1.CardName.ROBIN_HAULINGS]: 'image',
    [CardName_1.CardName.ROBINSON_INDUSTRIES]: 'bespoke',
    [CardName_1.CardName.SAGITTA_FRONTIER_SERVICES]: 'bespoke',
    [CardName_1.CardName.SATURN_SYSTEMS]: 'bespoke',
    [CardName_1.CardName.SEPTUM_TRIBUS]: 'bespoke',
    [CardName_1.CardName.SOLBANK]: 'bespoke',
    [CardName_1.CardName.SOYLENT_SEEDLING_SYSTEMS]: 'image',
    [CardName_1.CardName.SPIRE]: 'image',
    [CardName_1.CardName.SPLICE]: 'bespoke',
    [CardName_1.CardName.STEELARIS]: 'image',
    [CardName_1.CardName.STORMCRAFT_INCORPORATED]: 'bespoke',
    [CardName_1.CardName.TEMPEST_CONSULTANCY]: 'image',
    [CardName_1.CardName.TERACTOR]: 'css',
    [CardName_1.CardName.TERRALABS_RESEARCH]: 'bespoke',
    [CardName_1.CardName.THARSIS_REPUBLIC]: 'bespoke',
    [CardName_1.CardName.THE_ARCHAIC_FOUNDATION_INSTITUTE]: 'image',
    [CardName_1.CardName.THE_DARKSIDE_OF_THE_MOON_SYNDICATE]: 'image',
    [CardName_1.CardName.THE_GRAND_LUNA_CAPITAL_GROUP]: 'image',
    [CardName_1.CardName.THORGATE]: 'css',
    [CardName_1.CardName.TYCHO_MAGNETICS]: 'bespoke',
    [CardName_1.CardName.UNITED_NATIONS_MARS_INITIATIVE]: 'bespoke',
    [CardName_1.CardName.UNITED_NATIONS_MISSION_ONE]: 'bespoke',
    [CardName_1.CardName.UTOPIA_INVEST]: 'bespoke',
    [CardName_1.CardName.VALLEY_TRUST]: 'bespoke',
    [CardName_1.CardName.VIRON]: 'css',
    [CardName_1.CardName.VITOR]: 'bespoke',
    [CardName_1.CardName.VOLTAGON]: 'bespoke',
};
exports.default = vue_1.default.extend({
    name: 'CardCorporationLogo',
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    computed: {
        logos() {
            return logos;
        },
        CardName() {
            return CardName_1.CardName;
        },
        logoClass() {
            const type = logos[this.title];
            switch (type) {
                case 'image':
                case 'css':
                    const local = this.title.toLowerCase()
                        .replaceAll(' ', '-')
                        .replaceAll('&', '')
                        .replaceAll('--', '-');
                    return `card-${local}-logo`;
                default:
                    return '';
            }
        },
        capsTitle() {
            return logos[this.title] === 'image' ? '' : this.title.toUpperCase();
        },
    },
});
